import { FC, ReactNode } from "react";
import { Skeleton } from "@mui/material";
import { useAppSelector } from "@/store/hooks";
import { budgetDetailsByIdLoadingSelector } from "@/store/budgets/selectors/details-drawer/budgetDetailsByIdLoadingSelector";

interface BudgetDetailsRowSkeletonWrapperProps {
  children?: ReactNode;
}

export const BudgetDetailsRowSkeletonWrapper: FC<
  BudgetDetailsRowSkeletonWrapperProps
> = ({ children }) => {
  const loading = useAppSelector(budgetDetailsByIdLoadingSelector);

  if (loading) {
    return (
      <Skeleton
        width={150}
        height={20}
        variant="rectangular"
        sx={{
          borderRadius: 1,
        }}
      />
    );
  }

  return children;
};
